import moment from "moment"
import { DATEPICKER_TRANSLATE } from 'common/Constants';

export const generateLabelToShow = (fromDate, toDate) => {
    let labelToShow = `${moment(fromDate).format('DD/MM/YY')} al ${moment(toDate).format('DD/MM/YY')}`
    const startOfMonth = moment(fromDate).startOf('month').format('YYYY-MM-DD')
    const endOfMonth = moment(fromDate).endOf('month').format('YYYY-MM-DD')
    const isCurrentMonth = moment(fromDate).format('YYYY-MM-DD') === moment().startOf('month').format('YYYY-MM-DD') && moment(toDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    const isMonthPeriod = startOfMonth === moment(fromDate).format('YYYY-MM-DD') && endOfMonth === moment(toDate).format('YYYY-MM-DD')

    const isOneDay = moment(fromDate).format('YYYY-MM-DD') === moment(toDate).format('YYYY-MM-DD')
  
    if(isMonthPeriod || isCurrentMonth){
      labelToShow = `${DATEPICKER_TRANSLATE.MONTHS[moment(fromDate).format('M') - 1]} ${moment(fromDate).format('YYYY')}`
    }
  
    if(isOneDay){
      labelToShow = `${moment(fromDate).format('DD/MM/YY')}`
    }
    return labelToShow
  }